export default "<div class=\"toggle-button-icon-group\">\n  <ng-content></ng-content>\n</div>\n"